var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleEllipsis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    fill: "#216FB4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,0 C37.254834,0 48,10.745166 48,24 C48,37.254834 37.254834,48 24,48 C10.745166,48 0,37.254834 0,24 C0,10.745166 10.745166,0 24,0 Z M24,4.36363636 C13.1551358,4.36363636 4.36363636,13.1551358 4.36363636,24 C4.36363636,34.8448642 13.1551358,43.6363636 24,43.6363636 C34.8448642,43.6363636 43.6363636,34.8448642 43.6363636,24 C43.6363636,13.1551358 34.8448642,4.36363636 24,4.36363636 Z",
    id: "Oval",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(21, 11)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.49090909,
    cy: 3.49090909,
    r: 3.49090909
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.49090909,
    cy: 13.0909091,
    r: 3.49090909
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 3.49090909,
    cy: 22.6909091,
    r: 3.49090909
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleEllipsis);
export default __webpack_public_path__ + "static/media/circle-ellipsis.5cc17d2ac441824606c55f46cf6c3e41.svg";
export { ForwardRef as ReactComponent };